<template>
    <div class="text-center mt-64">
        <div class="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">Žádné zprávy</h3>
            <p v-if="search" class="mt-1 text-sm text-gray-500">
                Vypadá to, vyhledávání neodpovídají žádné zprávy...
            </p>
            <p v-else class="mt-1 text-sm text-gray-500">
                Vypadá to, že je tato složka zatím prázdná...
            </p>
            <div v-if="!$page.props.selectedUser?.settings?.automatic_delivery && $page.props.users.length > 0" class="mt-6">
                <button @click.prevent="refreshMessages(1)" type="button" class="border-gray-300 text-gray-500 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-offset-2 focus:border-indigo-500 focus:ring-indigo-500">
                    <!-- Heroicon name: solid/plus -->
                    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="-2.5 -2.5 25 25" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                    </svg>
                    stáhnout nové zprávy
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessagesTableNoMessages",
    emits: ['refreshMessages'],
    data(){
        return {
            settings: this.$page.props.settings,
            search: this.$page.props.search,
        }
    },
    methods: {
        refreshMessages(manual = 0){
            this.$emit('refreshMessages', manual);
        }
    }
}
</script>

<style scoped>

</style>
